import ReactGA from 'react-ga4'
import Title from '../components/ui/Title'
import '../styles/ui/ui.scss'
import '../styles/pages/product.scss'
import { useEffect, useState } from 'react'
import Button from "../components/ui/Button";
// const Products = () => {
//     return (
//         <div className='page-container'>
//             <Title text='PRODUCTS' />
//             <h1 className='product-title-red'>Nintendo Switch™ Deluxe Edition</h1>
//             <h2 className='product-availablenow'>Available Now</h2>
//             <div className='product-pair'>
//                 <img src='./img/products/nsw-de.webp' alt='NSW Deluxe Edition Glamshot' />
//                 <div className='product-links'>
//                     <a
//                         href='https://www.amazon.com/Legend-Heroes-Trails-Azure-Nintendo-Switch/dp/B09B1QVNT6'
//                         target='_blank'
//                         rel='noopener noreferrer'
//                     >
//                         <Button
//                             text='Amazon'
//                             type='solid'
//                             onClick={() => {
//                                 ReactGA.event({
//                                     category: 'Product Link',
//                                     action: 'Click',
//                                     label: `DE - NSW - Amazon`,
//                                 })
//                             }}
//                         />
//                     </a>
//                     <a
//                         href='https://www.amazon.ca/Legend-Heroes-Trails-Nintendo-Switch/dp/B09B1QVNT6/'
//                         target='_blank'
//                         rel='noopener noreferrer'
//                     >
//                         <Button
//                             text='Amazon (CA)'
//                             type='solid'
//                             onClick={() => {
//                                 ReactGA.event({
//                                     category: 'Product Link',
//                                     action: 'Click',
//                                     label: `DE - NSW - Amazon (CA)`,
//                                 })
//                             }}
//                         />
//                     </a>
//                     <a
//                         href='https://www.gamestop.com/video-games/nintendo-switch/products/the-legend-of-heroes-trails-to-azure---nintendo-switch/390871.html'
//                         target='_blank'
//                         rel='noopener noreferrer'
//                     >
//                         <Button
//                             text='GameStop'
//                             type='solid'
//                             onClick={() => {
//                                 ReactGA.event({
//                                     category: 'Product Link',
//                                     action: 'Click',
//                                     label: `DE - NSW - GameStop`,
//                                 })
//                             }}
//                         />
//                     </a>
//                     <a
//                         href='https://www.bestbuy.com/site/the-legend-of-heroes-trails-to-azure-nintendo-switch/6481233.p?skuId=6481233'
//                         target='_blank'
//                         rel='noopener noreferrer'
//                     >
//                         <Button
//                             text='BestBuy'
//                             type='solid'
//                             onClick={() => {
//                                 ReactGA.event({
//                                     category: 'Product Link',
//                                     action: 'Click',
//                                     label: `DE - NSW - BestBuy`,
//                                 })
//                             }}
//                         />
//                     </a>{' '}
//                     <a
//                         href='https://www.walmart.com/ip/The-Legend-of-Heroes-Trail-to-Azure-Deluxe-Edition-Nintendo-Switch/901905779'
//                         target='_blank'
//                         rel='noopener noreferrer'
//                     >
//                         <Button
//                             text='Walmart'
//                             type='solid'
//                             onClick={() => {
//                                 ReactGA.event({
//                                     category: 'Product Link',
//                                     action: 'Click',
//                                     label: `DE - NSW - Walmart`,
//                                 })
//                             }}
//                         />
//                     </a>
//                 </div>
//             </div>
//             <h1 className='product-title-blue'>PlayStation®4 Deluxe Edition</h1>{' '}
//             <h2 className='product-availablenow'>Available Now</h2>
//             <div className='product-pair'>
//                 <img src='./img/products/ps4-de.webp' alt='PS4 Deluxe Edtion Glamshot' />
//                 <div className='product-links'>
//                     <a
//                         href='https://www.amazon.com/Legend-Heroes-Trails-Azure-PlayStation-4/dp/B09B1TBQLB/'
//                         target='_blank'
//                         rel='noopener noreferrer'
//                     >
//                         <Button
//                             text='Amazon'
//                             type='solid'
//                             onClick={() => {
//                                 ReactGA.event({
//                                     category: 'Product Link',
//                                     action: 'Click',
//                                     label: `DE - PS4 - Amazon`,
//                                 })
//                             }}
//                         />
//                     </a>
//                     <a
//                         href='https://www.amazon.com/Legend-Heroes-Trails-Azure-PlayStation-4/dp/B09B1TBQLB/ref=sr_1_1?crid=121JZSHUUDTTH&keywords=trails%2Bto%2Bazure&qid=1658790920&sprefix=trails%2Bto%2Bazur%2Caps%2C142&sr=8-1&th=1'
//                         target='_blank'
//                         rel='noopener noreferrer'
//                     >
//                         <Button
//                             text='Amazon (CA)'
//                             type='solid'
//                             onClick={() => {
//                                 ReactGA.event({
//                                     category: 'Product Link',
//                                     action: 'Click',
//                                     label: `DE - PS4 - Amazon (CA)`,
//                                 })
//                             }}
//                         />
//                     </a>
//                     <a
//                         href='https://www.gamestop.com/video-games/playstation-4/products/the-legend-of-heroes-trails-to-azure---playstation-4/390872.html'
//                         target='_blank'
//                         rel='noopener noreferrer'
//                     >
//                         <Button
//                             text='GameStop'
//                             type='solid'
//                             onClick={() => {
//                                 ReactGA.event({
//                                     category: 'Product Link',
//                                     action: 'Click',
//                                     label: `DE - PS4 - GameStop`,
//                                 })
//                             }}
//                         />
//                     </a>

//                     <a
//                         href='https://www.bestbuy.com/site/the-legend-of-heroes-trails-to-azure-playstation-4/6481232.p?skuId=6481232'
//                         target='_blank'
//                         rel='noopener noreferrer'
//                     >
//                         <Button
//                             text='BestBuy'
//                             type='solid'
//                             onClick={() => {
//                                 ReactGA.event({
//                                     category: 'Product Link',
//                                     action: 'Click',
//                                     label: `DE - PS4 - BestBuy`,
//                                 })
//                             }}
//                         />
//                     </a>
//                     <a
//                         href='https://www.walmart.com/ip/The-Legend-of-Heroes-Trails-to-Azure-Deluxe-Edition-PlayStation-4/613736772'
//                         target='_blank'
//                         rel='noopener noreferrer'
//                     >
//                         <Button
//                             text='Walmart'
//                             type='solid'
//                             onClick={() => {
//                                 ReactGA.event({
//                                     category: 'Product Link',
//                                     action: 'Click',
//                                     label: `DE - PS4 - Walmart`,
//                                 })
//                             }}
//                         />
//                     </a>
//                 </div>
//             </div>
//             <section className='pc-products-section'> <div>
//                         {' '}
//                 <h1 className='product-title-blue'>PC Versions</h1>{' '}
//                 <h2 className='product-availablenow'>Available Now</h2>
//                 <iframe
//                     src='https://store.steampowered.com/widget/1668520/'
//                     width='646'
//                     height='190'
//                     className='steam'
//                 ></iframe>
//                 <div className='product-links-digital'>

//                         <a
//                             href='https://store.epicgames.com/en-US/p/the-legend-of-heroes-trails-to-azure'
//                             target='_blank'
//                             rel='noopener noreferrer'
//                         >
//                             <Button
//                                 text='Epic Games Store'
//                                 type='solid'
//                                 onClick={() => {
//                                     ReactGA.event({
//                                         category: 'Product Link',
//                                         action: 'Click',
//                                         label: `DE - Digital - Epic Games Store`,
//                                     })
//                                 }}
//                             />
//                         </a>{' '}
//                         <a
//                             href='https://www.gog.com/en/game/the_legend_of_heroes_trails_to_azure'
//                             target='_blank'
//                             rel='noopener noreferrer'
//                         >
//                             <Button
//                                 text='GOG'
//                                 type='solid'
//                                 onClick={() => {
//                                     ReactGA.event({
//                                         category: 'Product Link',
//                                         action: 'Click',
//                                         label: `DE - Digital - GOG`,
//                                     })
//                                 }}
//                             />
//                         </a>
//                     </div>{' '}
//                 </div>
//             </section>{' '}
//             <h1 className='product-title'>Merchandise</h1>
//             <div className='product-pair'>
//                 <img src='./img/products/acrylic.png' alt='ACRYLIC HERE' className='merch' />
//                 <div className='product-links'>
//                     <a
//                         href='https://store.nisamerica.com/the-legend-of-heroes-trails-to-azure/trails-to-azure-azure-legends-acrylic-print'
//                         target='_blank'
//                         rel='noopener noreferrer'
//                     >
//                         <Button
//                             text='NISA Online Store'
//                             type='solid'
//                             onClick={() => {
//                                 ReactGA.event({
//                                     category: 'Product Link',
//                                     action: 'Click',
//                                     label: `Acrylic - NISA`,
//                                 })
//                             }}
//                         />
//                     </a>
//                 </div>
//             </div>
//         </div>
//     )
// }
export const Products = () => {
    const gameData = {
        path: 'legend-heroes-trails-azure', // 1 Please input game pathname
        steam: '1668520', // 2 Please input Steam ID if available
    }
    const gameData2 = {
        path: 'crossbell', // 1 Please input game pathname
        steam: '1668510', // 2 Please input Steam ID if available
    }
    const imagePath = {
        'PlayStation®5': 'ps5',
        'PlayStation®4': 'ps4',
        Xbox: 'xbox',
        'Nintendo Switch™': 'nsw',
        'Nintendo Switch™2': 'ns2',
    }

    const [editions, setEditions] = useState([])
    const [crossBellEditions, setCrossBellEditions] = useState([])
    // const [limitedEditions, setLimitedEditions] = useState([])
    const [data, setData] = useState([])
    const [crossbellData, setCrossbellData] = useState([])
    const [platformDeluxe, setPlatformDeluxe] = useState('Nintendo Switch™2')
    const dataReduced = Object.values(data).reduce((acc, curr) => {
        if (curr.edition !== 'Limited Edition' && curr.platform !== 'PC' && !acc.includes(curr.edition)) {
            acc.push(curr.edition)
        }
        return acc
    }, [])
    const platformReduced = Object.values(data).reduce((acc, curr) => {
        if (curr.platform !== 'PC' && curr.platform !== 'Xbox One' && !acc.includes(curr.platform)) {
            acc.push(curr.platform)
        }

        return acc
    }, [])

    useEffect(() => {
        fetch(`https://www.nisamerica.com/api/game/${gameData.path}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText)
                }
                return response.json()
            })
            .then((data) => {
                const editions = Object.values(data.game.retailerLinks.map((item) => item.edition))
                const formattedData = data.game.retailerLinks.map((item) => {
                    return {
                        url: item.url,
                        store: item.store,
                        edition: item.edition,
                        platform: item.platform,
                        region: item.region,
                    }
                })
                const sortedData = formattedData.sort((a, b) => a.store.localeCompare(b.store))
                setEditions(editions)
                setData(sortedData)
                console.log(data)
            })
            .catch((error) => {
                console.error('There has been a problem with your fetch operation:', error)
            })
    }, [])
    // useEffect(() => {
    //     fetch(`https://www.nisamerica.com/api/game/${gameData2.path}`)
    //         .then((response) => {
    //             if (!response.ok) {
    //                 throw new Error('Network response was not ok ' + response.statusText)
    //             }
    //             return response.json()
    //         })
    //         .then((data) => {
    //             const crossbelleditions = Object.values(data.game.retailerLinks.map((item) => item.edition))
    //             const formattedData = data.game.retailerLinks.map((item) => {
    //                 return {
    //                     url: item.url,
    //                     store: item.store,
    //                     edition: item.edition,
    //                     platform: item.platform,
    //                     region: item.region,
    //                 }
    //             })
    //             // Sort retaiers in alphabetical order
    //             const sortedData = formattedData.sort((a, b) => a.store.localeCompare(b.store))
    //             setCrossBellEditions(crossbelleditions)
    //             setCrossbellData(sortedData)
    //         })
    //         .catch((error) => {
    //             console.error('There has been a problem with your fetch operation:', error)
    //         })
    // }, [])
    const FilterLE = (region) =>
        crossbellData.filter((item) => item.region === region && item.edition === 'Limited Edition')
    const FilterRegion = (region, platform) =>
        data.filter((item) => item.region === region && item.edition === 'Deluxe Edition' && item.platform === platform)
    const ButtonPlatformSelecter = ({ children, link, gaCategory, gaLabel, onClickEvent, active }) => {
        return (
            <>
                <button
                    onClick={
                        (() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: { gaCategory },
                                label: { gaLabel },
                            })
                        },
                        onClickEvent)
                    }
                    to={link}
                    activeclassname='active'
                    className={`${active ? 'active-platform' : 'inactive-platform'} platform-button`}
                >
                    <p className='not-italic'>{children}</p>
                    {active && (
                        <i>
                            <svg xmlns='http://www.w3.org/2000/svg' width='12' height='14' viewBox='0 0 9 14'>
                                <path
                                    d='M7,0l7,9H0Z'
                                    transform='translate(9) rotate(90)'
                                    fill='rgb(4, 172, 198)'
                                ></path>
                            </svg>
                        </i>
                    )}
                </button>
            </>
        )
    }
    const ButtonRetailer = ({ dataPlatform, dataUrl, dataStore }) => {
        return (
            <button className='retailer-button '>
                <a
                    onClick={() => {
                        ReactGA.event({
                            action: 'click',
                            event: 'link',
                            category: 'Products',
                            label: `DE ${dataPlatform} ${dataStore}`,
                        })
                    }}
                    target='_blank'
                    rel='noreferrer'
                    href={`${dataUrl}`}
                >
                    <p>{dataStore}</p>
                </a>
            </button>
        )
    }

    return (
        <>
            <div className='page-container-products'>
                <Title text='PRODUCTS' />
                <nav className='media-nav'>
                    <a href='#lmtedition'>
                        {' '}
                        <h1 className='media-link'>Limited Edition</h1>
                    </a>

                    <a href='#dlxedition'>
                        {' '}
                        <h1 className='media-link'>Deluxe Edition</h1>
                    </a>

                    <a href='#digital'>
                        {' '}
                        <h1 className='media-link'>Digital Edition</h1>
                    </a>
                </nav>

                {editions.includes('Limited Edition') && (
                    <section id='ltdedition' className='section'>
                        {/* <h1 className=''>Limited Edition</h1>{' '} */}
                        <div className='products-title'>
                            <h1 className=''>Limited Edition</h1>
                            {/* <h2 className=''>Available Now</h2> */}
                        </div>
                        <div className='glamshot'>
                            <img
                                src={`./img/products/le-ps5.webp`}
                                // src={`${process.env.PUBLIC_URL}/assets/le.jpg`}
                                alt='le glamshot'
                            />
                        </div>{' '}
                        <div className='captcha-container'>
                            <h3 className=''>NIS America Online Store</h3>
                            {/* <h2 className=''>Available Now</h2> */}
                        </div>
                        <div className='le-buttons'>
                            <button className='btn-solid button '>
                                <a
                                    onClick={() => {
                                        ReactGA.event({
                                            action: 'click',
                                            event: 'link',
                                            category: 'Products',
                                            label: `Limited Edition - PS5 - NISA Online Store`,
                                        })
                                    }}
                                    target='_blank'
                                    rel='noreferrer'
                                    href={`https://store.nisamerica.com/products/crossbell-limited-edition?variant=43053256048688`}
                                >
                                    <p>PlayStation®5</p>
                                </a>
                            </button>
                            <button>
                                <a
                                    onClick={() => {
                                        ReactGA.event({
                                            action: 'click',
                                            event: 'link',
                                            category: 'Products',
                                            label: `Limited Edition - NS2 - NISA Online Store`,
                                        })
                                    }}
                                    target='_blank'
                                    rel='noreferrer'
                                    href={`https://store.nisamerica.com/products/crossbell-limited-edition?variant=43053256015920`}
                                >
                                    <p>Nintendo Switch™2</p>
                                </a>
                            </button>
                        </div>
                    </section>
                )}
                <section id='dlxedition' className='section'>
                    <div className='products-title'>
                        <h1 className=''>Deluxe Edition</h1>
                        {/* <h2 className=''>Available Now</h2> */}
                    </div>
                    <div className='de-container'>
                        <div className='platform-selecter'>
                            <ButtonPlatformSelecter
                                onClickEvent={() => setPlatformDeluxe('Nintendo Switch™2')}
                                active={platformDeluxe === 'Nintendo Switch™2'}
                            >
                                Nintendo Switch™2
                            </ButtonPlatformSelecter>
                            <ButtonPlatformSelecter
                                onClickEvent={() => setPlatformDeluxe('Nintendo Switch™')}
                                active={platformDeluxe === 'Nintendo Switch™'}
                            >
                                Nintendo Switch™
                            </ButtonPlatformSelecter>
                            <ButtonPlatformSelecter
                                onClickEvent={() => setPlatformDeluxe('PlayStation®5')}
                                active={platformDeluxe === 'PlayStation®5'}
                            >
                                PlayStation®5
                            </ButtonPlatformSelecter>
                            <ButtonPlatformSelecter
                                onClickEvent={() => setPlatformDeluxe('PlayStation®4')}
                                active={platformDeluxe === 'PlayStation®4'}
                            >
                                PlayStation®4
                            </ButtonPlatformSelecter>
                        </div>{' '}
                        <div className='de-wrapper'>
                            <div className='de-glamshot'>
                                <img
                                    className='packshot'
                                    src={`./img/products/de-${imagePath[platformDeluxe]}.webp`}
                                    alt={`Deluxe Edition ${imagePath[platformDeluxe]}`}
                                />
                            </div>
                            <h2 className=''>
                                <div className=''>
                                    <h2 className='available-now'>
                                        {imagePath[platformDeluxe] === 'ps5' || imagePath[platformDeluxe] === 'ns2'
                                            ? 'Coming September 10, 2026'
                                            : 'Available Now'}
                                    </h2>
                                </div>
                            </h2>
                            <div>
                                {FilterRegion('NA', platformDeluxe).length > 0 && (
                                    <div className=''>
                                      
                                        <div className='captcha-container'>
                                            <h3>North America</h3>
                                        </div>
                                        <div className='retailer-buttons'>
                                            {FilterRegion('NA', platformDeluxe).map((data, i) => (
                                                <div key={i}>
                                                  
                                                    <ButtonRetailer
                                                        dataPlatform={data.platform}
                                                        dataUrl={data.url}
                                                        dataStore={data.store}
                                                        gaCategory='Product'
                                                        gaLabel={`NA - Deluxe Edition - ${data.platform} - ${data.store}`}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {FilterRegion('EU', platformDeluxe).length > 0 && (
                                    <div>
                               
                                        <div className='captcha-container'>
                                            <h3>Europe</h3>
                                        </div>
                                        <div className='retailer-buttons'>
                                            {FilterRegion('EU', platformDeluxe).map((data, i) => (
                                                <div key={i}>
                                                    <ButtonRetailer
                                                        dataPlatform={data.platform}
                                                        dataUrl={data.url}
                                                        dataStore={data.store}
                                                        gaCategory='Product'
                                                        gaLabel={`EU - Deluxe Edition - ${data.platform} - ${data.store}`}
                                                    />{' '}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {FilterRegion('ANZ', platformDeluxe).length > 0 && (
                                    <div>
                                        <h3>Oceania</h3>
                                        <div className='retailer-buttons'>
                                            {FilterRegion('ANZ', platformDeluxe).map((data, i) => (
                                                <div key={i}>
                                                    <ButtonRetailer
                                                        dataPlatform={data.platform}
                                                        dataUrl={data.url}
                                                        dataStore={data.store}
                                                        gaCategory='Product'
                                                        gaLabel={`ANZ - Deluxe Edition - ${data.platform} - ${data.store}`}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>{' '}
                    </div>
                </section>
                <section id='digital' className='section'>
                    <div className='products-title'>
                        <h1 className=''>Digital Edition</h1>
                        {/* <h2 className=''>Available Now</h2> */}
                    </div>
                    <div className='steamcontainer'>
                        <iframe
                            title={gameData.path}
                            src={`https://store.steampowered.com/widget/${gameData.steam}/`}
                            style={{ maxWidth: '900px' }}
                            frameBorder='0'
                            onClick={() => {
                                ReactGA.event({
                                    action: 'click',
                                    event: 'link',
                                    category: 'Product',
                                    label: 'Deluxe Ediiton - PC - Steam',
                                })
                            }}
                        ></iframe>
                    </div>
                </section>
            </div>
        </>
    )
}
export default Products
